import React, {useState} from 'react'
import {Box, PaletteColor, Typography} from '@mui/material'
import {Transaction} from '../../domain/Transaction'
import {TransactionTypeCode} from '../../domain/TransactionType'
import {TransactionCard} from './TransactionCard'
import {TransactionEditSheet} from './TransactionEditSheet'
import {RecurringOccurrenceEditor} from './RecurringOccurrenceEditor'
import {applyAmountModification} from '../../service/applyAmountModification'

type TransactionCardListProps = {
  transactions: Transaction[],
  onTransactionUpdate: (updatedTransaction: Transaction) => void,
  onTransactionDelete: (transactionId: string) => void,
  monthColor: PaletteColor,
}

export const TransactionCardList: React.FC<TransactionCardListProps> = ({transactions, onTransactionUpdate, onTransactionDelete}) => {
  const [editingId, setEditingId] = useState<string | null>(null)
  const editing = transactions.find(t => t.id === editingId) ?? null

  const toggleType = (t: Transaction) => {
    const type = t.type === TransactionTypeCode.CREDIT ? TransactionTypeCode.DEBIT : TransactionTypeCode.CREDIT
    onTransactionUpdate({...t, type})
  }

  const closeEditor = () => setEditingId(null)

  if (transactions.length === 0) {
    return <Box sx={{p: 2, textAlign: 'center'}}><Typography color="text.secondary">Pas de transaction</Typography></Box>
  }

  return (
    <Box sx={{p: 1}}>
      {transactions.map(t => (
        <TransactionCard
          key={t.id}
          transaction={t}
          onToggleType={() => toggleType(t)}
          onToggleChecked={(checked) => onTransactionUpdate({...t, checked})}
          onEdit={() => setEditingId(t.id)}
        />
      ))}

      {editing && !editing.recurrenceId && (
        <TransactionEditSheet
          open={editingId !== null}
          transaction={editing}
          onClose={closeEditor}
          onSave={onTransactionUpdate}
          onDelete={(id) => {onTransactionDelete(id); closeEditor()}}
        />
      )}

      {editing && editing.recurrenceId && (
        <RecurringOccurrenceEditor
          open={editingId !== null}
          transaction={editing}
          onClose={closeEditor}
          onApply={(newAmount, justification) =>
            onTransactionUpdate(applyAmountModification(editing, newAmount, justification, new Date().toISOString()))
          }
        />
      )}
    </Box>
  )
}
